<template>
  <Link
    tag="li"
    :href="route('markencode.brand-typology.index', {slug: word.slug})"
    class="col-span-1 flex items-center bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden"
  >
    <div
      class="shrink-0 flex items-center justify-center w-12 h-12 text-gray-400 text-center text-2xl leading-5 font-extralight bg-gray-200"
    >
      <word-icon :word="word"></word-icon>

    </div>

    <div class="flex-1 flex px-4 py-2 truncate">
      <div
        class="w-10/12 flex items-center text-gray-900 leading-5 font-medium hover:text-gray-600 transition ease-in-out duration-150 truncate text-xs 2xl:text-sm break-words"
      >
        {{ word.word }}
        <!-- <svg
          v-if="word.positive"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-5 h-5 text-gray-400"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 6v12m6-6H6"
          />
        </svg> -->

        <!-- <svg
          v-if="!word.positive"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-5 h-5 text-gray-400"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
        </svg> -->
      </div>
      <p class="w-2/12 text-xs leading-5 text-gray-500 px-1">
        <zone-color-icons :colors="word.zone_colors" :mini="true"></zone-color-icons>
      </p>
    </div>
    <!-- <div class="shrink-0 pr-2">
      
    </div>-->
  </Link>
</template>

<script>
import ZoneColorIcons from '@/Pages/Markencode/Shared/ZoneColorIcons.vue';
import WordIcon from '@/Pages/Markencode/Shared/WordIcon.vue';


export default {

  components: {
    ZoneColorIcons,
    WordIcon,
    
  },

  props: {
    word: {
      required: true,
      default: Object
    },
  },
};
</script>